import React from 'react';
import { Components } from './styled';

const DayEvents = ({ date, hasDailyAlux }: { date: Date; hasDailyAlux?: boolean }) => {
  return (
    <Components.DayTileWrapper>
      {date.getDate()}
      <Components.DotsWrapper>{hasDailyAlux && <Components.Dot variant={'appointment'} />}</Components.DotsWrapper>
    </Components.DayTileWrapper>
  );
};

export default DayEvents;
